export const GEOJSONPOINT = 0
export const GEOJSONLINE = 1
export const geometryIds = [GEOJSONPOINT, GEOJSONLINE]